export default (chart) => {
  const PADDING = 32; // pixels

  const paddedWidth = chart.canvas.width + PADDING * 2;
  const paddedHeight = chart.canvas.height + PADDING * 2;

  // We're using a duplicated canvas to avoid blinking of
  // the rendered chart in the browser.
  const offscreenCanvas = document.createElement("canvas");
  offscreenCanvas.width = paddedWidth;
  offscreenCanvas.height = paddedHeight;

  const offscreenCtx = offscreenCanvas.getContext("2d");

  offscreenCtx.fillStyle = "#FFF";
  offscreenCtx.fillRect(0, 0, paddedWidth, paddedHeight);

  // Copy original chart image
  offscreenCtx.drawImage(chart.canvas, PADDING, PADDING);

  offscreenCtx.lineWidth = 6;
  offscreenCtx.strokeStyle = "#d0d7de"; // Github border color around rendered Markdown file
  offscreenCtx.strokeRect(0, 0, paddedWidth, paddedHeight);

  const a = document.createElement("a");
  a.href = offscreenCanvas.toDataURL("image/png");
  a.download = "chart.png";
  a.click();
};
